const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일(수정일)",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["작업구분", "작성일(수정일)"] },
      },
      {
        component: "search-select-company-name",
        label: "부서명",
        value: "companyName",
        query: { cName: "companyName" },
        options: {
          default: "",
          targetKey: "body.inputA_3",
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },
  getHead: () => {
    return [
      { name: "종사자 사업장명", key: "body.inputA_0" },
      { name: "성명", key: "body.enc.inputA_7" },
      { name: "종사자 부서", key: "body.inputA_3" },
      { name: "구분", key: "body.inputA_4" },
      { name: "직종", key: "body.inputB_7" },
      { name: "작성자", key: "stdInfo.writer_name" },
      { name: "작성일(수정일)", key: "updated_at" },
    ];
    return [{ name: "종사자 사업장명" }, { name: "성명" }, { name: "종사자 부서" }, { name: "구분" }, { name: "직종" }, { name: "작성자" }, { name: "작성일(수정일)" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).inputA_0;
        case 1:
          return func.getContent(value).enc.inputA_7;
        case 2:
          return func.getContent(value).inputA_3;
        case 3:
          return func.getContent(value).inputA_4;
        case 4:
          return func.getContent(value).inputB_7;
        case 5:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 6:
          return func.getCreatedDate(value.updated_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
